import * as M from '@/messages/wishlist';

import * as S from './Orseparator.styles';
export const OrSeparator = () => {
  return (
    <S.OrSeparatorContainer>
      <S.Line />
      <S.TextWrapper>{M.Or}</S.TextWrapper>
      <S.Line />
    </S.OrSeparatorContainer>
  );
};
